const eventBookingShouldBeGrouped = function (record) {
  const { eventId, dateMode } = record.attributes
  const startsAt = record.attributes.startsAt.slice(0, 10)
  const endsAt = dateMode == "date_time" ? record.attributes.startsAt.slice(0, 10) : record.attributes.endsAt.slice(0, 10)
  return [eventId, startsAt, endsAt].join("|")
}
export default eventBookingShouldBeGrouped
